import React, { useMemo } from 'react'
import Join from 'sections/Join/Join'
import Intro from '@/sections/Intro/Intro'
import ClipText from '@/sections/ClipText/ClipText'
import Articles from '@/sections/Articles/Articles'
import Connections from '@/sections/Connections/Connections'
import Capture from '@/sections/Capture/Capture'
import WebClipper from '@/sections/WebClipper/WebClipper'
import Bidirectionnal from '@/sections/Bidirectionnal/Bidirectionnal'
import Members from '@/sections/Members/Members'
import JoinFooter from '@/sections/JoinFooter/JoinFooter'
import dynamic from 'next/dynamic'
import Pricing from '@/components/Pricing/Pricing'
import Ai from '@/components/Ai/Ai'
const UniversalInbox = dynamic(() => import('@/sections/UniversalInbox/UniversalInbox'), { ssr: false })

export enum ESectionType {
  ai = 'ai',
  intro = 'intro',
  clipText = 'clipText',
  articles = 'articles',
  join = 'join',
  connections = 'connections',
  clipAnything = 'clipAnything',
  capture = 'capture',
  pricing = 'pricing',
  universalInbox = 'universalInbox',
  webClipper = 'webClipper',
  bidirectionnal = 'bidirectionnal',
  members = 'members',
  joinFooter = 'joinFooter',
}

type Props = {
  type?: ESectionType
  className?: string
}

const Section = ({ type, className }: Props) => {
  const [section] = useMemo(() => {
    let section
    switch (type) {
      case ESectionType.ai:
        section = <Ai />
        break
      case ESectionType.intro:
        section = <Intro />
        break
      case ESectionType.clipText:
        section = <ClipText />
        break
      case ESectionType.articles:
        section = <Articles />
        break
      case ESectionType.connections:
        section = <Connections />
        break
      case ESectionType.join:
        section = <Join />
        break
      case ESectionType.capture:
        section = <Capture />
        break
      case ESectionType.universalInbox:
        section = <UniversalInbox />
        break
      case ESectionType.webClipper:
        section = <WebClipper />
        break
      case ESectionType.bidirectionnal:
        section = <Bidirectionnal />
        break
      case ESectionType.members:
        section = <Members className={className} />
        break
      case ESectionType.pricing:
        section = <Pricing />
        break
      case ESectionType.joinFooter:
        section = <JoinFooter className={className} />
        break
      default:
        section = <Join />
        break
    }

    return [section]
  }, [type, className])

  return section
}

export default Section
